// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .trade-in-slider--1UzxM{font-size:inherit;margin-top:20px}.precise-price-app .trade-in-slider__slider--27Rhm{max-width:320px;margin:0 auto}.precise-price-app .trade-in-slider__subtitle--1mWGW{font-size:14px;line-height:1em;font-weight:700;text-align:center;color:var(--font-color);margin-top:5px}", ""]);
// Exports
exports.locals = {
	"tradeInSlider": "trade-in-slider--1UzxM",
	"tradeInSliderSlider": "trade-in-slider__slider--27Rhm",
	"tradeInSliderSubtitle": "trade-in-slider__subtitle--1mWGW"
};
module.exports = exports;
